import { defaultPictogram, defaultFilterSgaPictograms } from "./state";

/**
 * Mutación que lista los pictogramas de SGA.
 *
 * @param {*} state.pictogramsSga - Estado de los pictogramas de SGA.
 * @param pictogramsSga - Pictogramas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setPictogramsSga(state, pictogramsSga) {
    state.pictogramsSga = pictogramsSga;
}

/**
 * Mutación que establece la acción a realizar (Crear o actualizar).
 *
 * @param {*} state.action - Estado de la acción.
 * @param action - Acción a realizar (create o edit).
 * @return {void}
 * @author Brandon Torres
 */
export function setActionPictogramSga(state, action) {
    state.action = action;
}

/**
 * Mutación que establece el pictograma por defecto.
 *
 * @param {*} state.pictogram - Estado del pictograma.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultPictogramSga(state) {
    state.pictogram = defaultPictogram();
}

/**
 * Mutación que establece el filtro de pictogramas de SGA por defecto.
 *
 * @param {*} state.filterPictogramsSga - Estado del filtro de pictogramas de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setDefaultFilterSgaPictograms(state) {
    state.filterPictogramsSga = defaultFilterSgaPictograms();
}

/**
 * Mutación que establece la cantidad de pictogramas por página.
 *
 * @param per_page - Cambio de cantidad de registros por página.
 * @param {*} state.filterPictogramsSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterPictogramsSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangeSizePagination(state, per_page) {
    state.filterPictogramsSga = {
        ...state.filterPictogramsSga,
        page: 1,
        per_page: per_page,
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param page - Cambio de página actual.
 * @param {*} state.filterPictogramsSga.page - Página actual.
 * @return {void}
 * @author Brandon Torres
 */
export function loadAfterChangePagePagination(state, page) {
    state.filterPictogramsSga.page = page;
}

/**
 * Mutación que establece el paginador de registros de pictogramas.
 *
 * @param paginate - Paginación de registros.
 * @param {*} state.filterPictogramsSga.page - Página actual.
 * @param {*} state.filterPictogramsSga.per_page - Cantidad de registros por página.
 * @param {*} state.filterPictogramsSga.total - Total de registros.
 * @return {void}
 * @author Brandon Torres
 */
export function setPaginatePictogramsSga(state, paginate) {
    state.filterPictogramsSga = {
        ...state.filterPictogramsSga,
        page: paginate.current_page,
        per_page: paginate.per_page,
        total: paginate.total,
    };
}

/**
 * Mutación que establece el pictograma de SGA.
 *
 * @param {*} state.pictogram - Estado del pictograma.
 * @param pictogram - Pictograma de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setPictogramSga(state, pictogram) {
    state.pictogram = {
        id: pictogram.id,
        name: pictogram.name,
        image: null,
        imageBase64: pictogram.image,
    };
}

/**
 * Mutación que establece los pictogramas activos de SGA.
 *
 * @param {*} state.activePictograms - Estado de pictogramas activos de SGA.
 * @param activePictograms - Pictogramas activos de SGA.
 * @return {void}
 * @author Brandon Torres
 */
export function setActivePictogramsSga(state, activePictograms) {
    state.activePictograms = activePictograms;
}
